/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type HpRespLocationsModule_homepage$ref = any;
export type HpRespLocationsModule_homepage = {
    readonly locationsModule: ({
        readonly title?: string | null;
        readonly subtitle?: string | null;
        readonly location?: {
            readonly title: string | null;
            readonly imageUrl: string | null;
            readonly items: ReadonlyArray<{
                readonly cmsId: number | null;
                readonly title: string | null;
                readonly link: string | null;
                readonly isLinkable: boolean | null;
            } | null> | null;
        } | null;
        readonly items?: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly title: string | null;
            readonly link: string | null;
            readonly imageUrl: string | null;
        } | null> | null;
    } & ({
        readonly title: string | null;
        readonly subtitle: string | null;
        readonly location: {
            readonly title: string | null;
            readonly imageUrl: string | null;
            readonly items: ReadonlyArray<{
                readonly cmsId: number | null;
                readonly title: string | null;
                readonly link: string | null;
                readonly isLinkable: boolean | null;
            } | null> | null;
        } | null;
        readonly items: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly title: string | null;
            readonly link: string | null;
            readonly imageUrl: string | null;
        } | null> | null;
    } | {
        /*This will never be '% other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    })) | null;
    readonly " $refType": HpRespLocationsModule_homepage$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "imageUrl",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "cmsId",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "link",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "HpRespLocationsModule_homepage",
        "type": "Homepage",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "LinkedField",
                "alias": "locationsModule",
                "name": "module",
                "storageKey": "module(type:\"locations\")",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "locations"
                    }
                ],
                "concreteType": null,
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "type": "LocationsModule",
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "subtitle",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "location",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Location",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    (v1 /*: any*/),
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "items",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "LocationItem",
                                        "plural": true,
                                        "selections": [
                                            (v2 /*: any*/),
                                            (v0 /*: any*/),
                                            (v3 /*: any*/),
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "isLinkable",
                                                "args": null,
                                                "storageKey": null
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "items",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Product",
                                "plural": true,
                                "selections": [
                                    (v2 /*: any*/),
                                    (v0 /*: any*/),
                                    (v3 /*: any*/),
                                    (v1 /*: any*/)
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '3a329b6c4e67e6042ca5ea8bb11ed154';
export default node;
